import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClinicalVisualization } from "./components/ClinicalVisualization/ClinicalVisualization";
import { EditQuestionnaireContextProvider } from "../../contexts/EditQuestionnaireContext";
import { LargeContentBox } from "@/components/common";
import { AttendanceTimer } from "./components/AttendanceTimer";

export function MedicalCare() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const hasAttendance = !!state?.encounterReference?.subject;

  // Recarregar a página zera `location.state`. Sem o atendimento não há o que
  // carregar e a tela ficava presa no spinner (loadingResponse nunca era
  // liberado), então devolvemos o profissional para a agenda.
  useEffect(() => {
    if (!hasAttendance) {
      navigate("/schedule", { replace: true });
    }
  }, [hasAttendance, navigate]);

  if (!hasAttendance) return null;

  return (
    <LargeContentBox>
      <EditQuestionnaireContextProvider>
        {/* Timer flutuante baseado em Encounter.actualPeriod.start */}
        <AttendanceTimer />
        <ClinicalVisualization />
      </EditQuestionnaireContextProvider>
    </LargeContentBox>
  );
}
